import React from 'react'

import type { AlertProps } from '@customTypes'
import { Icon } from '_components/icon'

import { Wrapper } from './components'
import { mapper } from './helpers/alert-mapper'

export const Alert: React.FC<AlertProps> = ({
  appearance,
  textContent,
  title,
  onClickClose,
  shouldShow,
  testId,
  ...props
}) =>
  shouldShow ? (
    <Wrapper {...props} data-testid={testId} appearance={appearance}>
      <Icon size="1.5rem" icon={mapper[appearance].icon} />
      <h2>{title || mapper[appearance].title}</h2>
      <h3>{textContent}</h3>
      {onClickClose && (
        <Icon size="1rem" icon="x" aria-label="close" onClick={onClickClose} />
      )}
    </Wrapper>
  ) : null
